import useRoutes from "./routes";
import {useContext} from "react";
import AuthContext from "./context/authContext";

function App() {
    const {auth} = useContext(AuthContext);
    const routes = useRoutes(auth);
    return (<div>{routes}</div>);
}

export default App;
